import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getTransliterateSuggestions } from "react-transliterate";
const InputTextTranslation = (props) => {
  const {
    inputText,
    translatedText = "",
    onChangeInputText,
    onChangeTranslatedText,
    placeholder,
    label,
    type,
    asterisk,
    disabled,
    firstInput,
    inputTextMeta,
    secondInput,
    translatedTextMeta,
  } = props;
  const { t } = useTranslation("master");
  const [translatedValue, setTranslatedValue] = useState(translatedText);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [debouncedInputText, setDebouncedInputText] = useState("");
  const [inputTextChanged, setInputTextChanged] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedInputText(inputText);
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputText]);

  const fetchTranslation = async () => {
    setLoading(true);
    setSuggestions([]);
    try {
     const transText= await getTransliterateSuggestions(
      debouncedInputText,
      {
        numOptions: 5,
        showCurrentWordAsLastSuggestion: false,
        lang: "mr", // target language
      },
    );
      onChangeTranslatedText(transText[0]);
      setSuggestions(transText);
      setLoading(false);
      setErrorMessage("");
    } catch (error) {
      console.error("Translation error:", error);
      setLoading(false);
      setErrorMessage("Failed to fetch translation. Please try again later.");
    }
  };
  useEffect(() => {
    if (debouncedInputText.trim() === "") {
      onChangeTranslatedText("");
      setSuggestions([]);
      return;
    }

    if (inputTextChanged && debouncedInputText) {
      fetchTranslation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedInputText, inputTextChanged]);

  useEffect(() => {
    onChangeTranslatedText(translatedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translatedValue]);

  const handleInputChange = (e) => {
    onChangeInputText(e.target.value);
    setInputTextChanged(true);
  };

  const handleSuggestionClick = (suggestion) => {
    onChangeTranslatedText(suggestion);
    setTranslatedValue(suggestion);
  };

  const handleTranslateChange = (e) => {
    onChangeTranslatedText(e.target.value);
    setTranslatedValue(e.target.value);
  };

  return (
    <>
      <label className="input-label">
        <span className="astoricstyle">{asterisk}</span>
        {t(label)}
      </label>
      <input
        {...firstInput}
        type={type}
        value={inputText}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={disabled}
        className={
          inputTextMeta.touched && inputTextMeta.error
            ? "input-style p-inputtext border-red-500"
            : "input-style p-inputtext"
        }
        data-testid="english"
      />
      <input
        {...secondInput}
        type={type}
        value={translatedText}
        onChange={handleTranslateChange}
        placeholder={t("Translated text")}
        disabled={disabled}
        className={
          translatedTextMeta.touched && translatedTextMeta.error
            ? "input-style p-inputtext border-red-500"
            : "input-style p-inputtext"
        }
      />

      {loading && <div>Loading...</div>}
      {errorMessage && <div className="text-red-600">{errorMessage}</div>}
      {inputTextMeta.touched && inputTextMeta.error && (
        <span className="text-red-500">{inputTextMeta.error}</span>
      )}
      {translatedTextMeta.touched &&
        translatedTextMeta.error &&
        inputTextMeta.touched &&
        !inputTextMeta.error && (
          <span className="text-red-500">{translatedTextMeta.error}</span>
        )}

      <ul className="suggestions-container">
        {suggestions.map((suggestion) => (
          <li
            key={suggestion}
            onClick={() => handleSuggestionClick(suggestion)}
            className="suggestion-item"
          >
            {suggestion}
          </li>
        ))}
      </ul>
      <style>
        {`
            .suggestions-container {
                display: flex;
                flex-wrap: wrap;
                gap: 5px;
                padding: 0;
            }
            .suggestion-item {
                cursor: pointer;
                list-style: none;
                background: #f5f5f5;
                padding: 5px 8px;
                border-radius: 10px;
                margin-bottom: 5px;
            }
            .suggestion-item:hover {
                background-color: #e0e0e0;
            }
        `}
      </style>
    </>
  );
};

export default InputTextTranslation;


